import type { VFC } from 'react';
import { useSelector } from 'react-redux';

import * as IssuesV2Store from '../../../redux/issuesV2';
import * as FallbackImage from './IssuesTableFallbackImages';
import useFetchIssuesAction from './hooks/useFetchIssuesAction';

/** The empty page of results when there are no results! */
export const EmptyIssuesPage: VFC = () => {
  const status = useSelector(IssuesV2Store.selectors.getStatus);
  const hasSearchOrFilterApplied = useSelector(IssuesV2Store.selectors.getHasSearchOrFilterApplied);
  const onResetButtonClick = useFetchIssuesAction(IssuesV2Store.actions.resetAllFilters);
  if (hasSearchOrFilterApplied) {
    return <FallbackImage.NoResults onResetButtonClick={onResetButtonClick} />;
  }
  return status === 'active'
    ? <FallbackImage.NoActiveIssues />
    : <FallbackImage.NoIgnoredIssues />;
};
